export const FAST_VERSION_VARIABLES = [
  {
    plan: "trial",
    variable: {
      type: "input",
      name: "first_name",
      title: "Prospect's first name",
      default: "",
      tip: "Prospect's first name",
      validation: { required: true, errorMessage: "Required" },
    },
  },
  {
    plan: "paid",
    variable: {
      type: "input",
      name: "last_name",
      title: "Prospect's last name",
      default: "",
      tip: "Prospect's last name",
      validation: { required: true, errorMessage: "Required" },
    },
  },
  {
    plan: "trial",
    variable: {
      type: "input",
      name: "company",
      title: "Prospect's company name",
      default: "",
      tip: "Prospect's company name",
      validation: { required: true, errorMessage: "Required" },
    },
  },
  {
    plan: "paid",
    variable: {
      type: "input",
      name: "offer_expiry_date",
      title: "Offer expiry date",
      default: "",
      tip: "Offer expiry date",
      validation: {
        required: true,
        errorMessage: "Offer expiry date is required",
      },
    },
  },
  {
    plan: "paid",
    variable: {
      type: "input",
      name: "phone",
      title: "Your phone number",
      default: "",
      tip: "Your phone number",
      validation: {
        required: true,
        regex: "^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\\s\\./0-9]*$",
        errorMessage: "Phone number is not valid",
      },
    },
  },
  {
    plan: "paid",
    variable: {
      type: "input",
      name: "number1",
      title: "Number #1",
      default: "",
      tip: "Number #1",
      validation: {
        required: true,
        regex: "^(-?[0-9][.]?[0-9]?)+$",
        errorMessage: "Must be a number",
      },
    },
  },
  {
    plan: "paid",
    variable: {
      type: "input",
      name: "number2",
      title: "Number #2",
      default: "",
      tip: "Number #2",
      validation: {
        required: true,
        regex: "^(-?[0-9][.]?[0-9]?)+$",
        errorMessage: "Must be a number",
      },
    },
  },
];
